import type { Signal } from '@preact/signals-react';
import type { FieldValues } from 'react-hook-form';
import { parseDate } from '../../../common/functions/parse-date';
import type { DynamicFormParentFieldValue } from '../../dynamic-form/dynamic-form.interfaces';
import OdinController from '../../dynamic-form/odin-controller.component';
import OdinDateCompetency from './date-competency.component';
import type { HfDateProps } from './hf-date.component';

export interface HfDateDependableProps<TFieldValues extends FieldValues = FieldValues>
  extends HfDateProps<TFieldValues> {
  parentValue?: Signal<Array<DynamicFormParentFieldValue>>;
}

export default function HfDateCompetency<TFieldValues extends FieldValues = FieldValues>({
  control,
  name,
  label,
  readOnly,
  required,
  onChange,
  fieldValueConverter,
  disabled,
  parentValue,
  labelStyles,
  fieldValidations,
}: HfDateDependableProps<TFieldValues>) {
  return (
    <OdinController
      name={name}
      control={control}
      onChange={onChange}
      fieldValueConverter={fieldValueConverter}
      render={({ field: { onChange, value: rawValue }, fieldState: { error } }) => {
        const value = rawValue as Date | string | null;
        return (
          <OdinDateCompetency
            label={label}
            value={value instanceof Date ? value : parseDate(value)}
            error={error?.message}
            onChange={onChange}
            readOnly={readOnly}
            required={required}
            disabled={disabled}
            parentValue={parentValue}
            labelStyles={labelStyles}
            fieldValidations={fieldValidations}
          />
        );
      }}
    />
  );
}
